<ul class="breadcrumb" *ngIf="environmentSettings.PSS">
    <li>
      <a [routerLink]="['/']">Home</a>
    </li>
    <li>KMP</li>
  </ul>
  <section class="card">
    <div class="card-header">
      <span class="cat__core__title">
          <strong id="pageTitle">KMP</strong>
      </span>
      <span style="float: right" *ngIf="environmentSettings.PSS">
        <a routerLink="/KMP/add">
          <button class="btn btn-success pull-right" class="btn btn-sm btn-primary mb-2" type="button">
            <i class="fa fa-plus"></i>Add KMP</button>
        </a>
      </span>
    </div>
    <div class="row">
      <div class="col-lg-12" id="KMPTabContainer">
        <ul class="nav nav-tabs" role="tablist">
          <li class="nav-item">
            <a class="nav-link active" href="javascript: void(0);" data-toggle="tab" data-target="#KMP" role="tab">KMP</a>
          </li>
          <!-- <li class="nav-item" >
            <a class="nav-link" href="javascript: void(0);" data-toggle="tab" data-target="#registerKMP" role="tab" (click)="tabRegisterOfKMPOnClickEvent()">Register of KMP</a>
          </li> -->
        </ul>
        <div class="tab-content">
          <div class="tab-pane active" id="KMP" role="tabcard">
            <div class="modal-body">
              <section class="card search-box">
                  <div class="card-header" (click)="toggleSearchDiv()" style="cursor: pointer;">Modify Search <span class="pull-right"><i class="fa fa-filter" aria-hidden="true"></i></span> </div>
                  <div class="card-block collapse" id="search-div" [ngClass]="{'collapse': !isSearchDivVisible}">
                  <div class="row">
                    <div class="col-lg-12">
                      <form (document:click)="appDate.close();cesDate.close();">
                        <div class="row">
                          <div class="col-lg-2">
                            <label>From Date :
                            </label>
                            <div class="input-group" (click)="$event.stopPropagation()">
                              <input id="fromDatecal" [maxDate]="futureFromDate" class="form-control" style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy"
                                name="dpAppointment" (ngModelChange)="setTodate($event)" ngbDatepicker #appDate="ngbDatepicker"
                                (click)="appDate.toggle();cesDate.close();" [(ngModel)]="FromDateModelInMasterKMP">
                              <button class="input-group-addon" (click)="appDate.toggle();cesDate.close();" type="button">
                                <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                              </button>
                            </div>
                          </div>
                          <div class="col-lg-2">
                            <label>To Date :
                            </label>
                            <div class="input-group" (click)="$event.stopPropagation()">
                              <input id="toDatecal" [minDate]="futureToDate" class="form-control" style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy"
                                name="dpCessation" ngbDatepicker #cesDate="ngbDatepicker" (click)="cesDate.toggle();appDate.close();"
                                [(ngModel)]="ToDateModelInMasterKMP" (ngModelChange)="setFromdate($event)">
                              <button class="input-group-addon" (click)="cesDate.toggle();appDate.close();" type="button">
                                <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                              </button>
                            </div>
                          </div>
                          <div class="col-sm-2">
                            <label>&nbsp;&nbsp;&nbsp;</label>
                            <div class="input-group">
                              <button type="button" [disabled]="response" class="btn btn-sm btn-primary mb-2" (click)="getKMPByParam()">
                                <i class="fa fa-search"></i>&nbsp;Search</button>
                              &nbsp;&nbsp;&nbsp;
                              <button type="button" [disabled]="response" class="btn btn-sm btn-default mb-2" (click)="getKMPByNullParam()">
                                <i class="fa fa-refresh"></i>&nbsp;Clear</button>
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </section>
              <div class="card-block datatable-card-block">
                <div class="row">
                  <div class="col-md-12">
                    <div class="margin-bottom-50">
                      <div class="table-responsive">
                        <table datatable [dtOptions]="dtOptionsOfMasterKMP" [dtTrigger]="dtTriggerMasterKMP" class="table table-hover compact cell-border nowrap stripe"
                          id="kmpmasterTable" style="cursor: pointer;">
                          <thead>
                            <tr>
                              <th>Name</th>
                              <th>Designation</th>
                              <th>Date of cessation</th>
                              <th>Date Of Appointment</th>
                              <th>Date of Board resolution</th>
                              <th>Status</th>
                              <th class="actionclass">Action
                                <!-- <span [appHasPermission]="{'Url': '/kmp/edit?goveva=true&email=', 'method':'put', 'menu': 'KMP'}">Action</span> -->
                              </th>
                              <th style="display:none">Date Of Appointment</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr *ngFor="let kmp of masterKmpList;">
                              <td tabindex="1">{{kmp.FirstName}} {{kmp.MiddleName}} {{kmp.LastName}}</td>
                              <td>
                                <span *ngIf="kmp.KmpProfession.length>0">
                                  {{kmp.KmpProfession[0].Designation}}
                                </span>
                                <span *ngIf="kmp.KmpProfession==0">
                                  N/A
                                </span>
                              </td>
  
  
                              <td>
                                <span *ngIf="kmp.KmpProfession.length>0">
                                  <span style="display: none">
                                   {{kmp.KmpProfession[0].CessationDate | date : "yMMdd"}}</span>
                                  {{kmp.KmpProfession[0].CessationDate | date : "dd-MM-y"}}
                                </span>
                                <span *ngIf="kmp.KmpProfession.length==0">
                                  N/A
                                </span>
                              </td>
  
  
  
  
                              <td>
                                <span *ngIf="kmp.KmpProfession.length>0">
                                  <span style="display: none">
                                   {{kmp.KmpProfession[0].AppointmentDate | date : "yMMdd"}}</span>
                                  {{kmp.KmpProfession[0].AppointmentDate | date : "dd-MM-y"}}
                                </span>
                                <span *ngIf="kmp.KmpProfession.length==0">
                                  N/A
                                </span>
                              </td>
                              <td>
                                <span *ngIf="kmp.KmpProfession.length>0">
                                  <span style="display: none">
                                   {{kmp.KmpProfession[0].BoardResolutionDate | date : "yMMdd"}}</span>
                                  {{kmp.KmpProfession[0].BoardResolutionDate | date : "dd-MM-y"}}
                                </span>
                                <span *ngIf="kmp.KmpProfession.length==0">
                                  N/A
                                </span>
                              </td>
                              <td>
                                <span *ngIf="kmp.Status==true">Active</span>
                               <span *ngIf="kmp.Status==false">Inactive </span>
                              </td>
                              <td style='white-space: nowrap'>
                                <a>
                                  <button type="button" [appHasPermission]="{'Url': '/register/KMP/edit?goveva=true&email=', 'method':'put', 'menu': 'KMP'}" class="btn-sm btn btn-warning" (click)="loadKmpDetailsById(kmp._id)">
                                    <span class="fa fa-pencil"></span>
                                  </button>
                                </a>
                              </td>
                              <td style="display:none">
                                  <span *ngIf="kmp.KmpProfession.length>0">                                 
                                    {{kmp.KmpProfession[0].AppointmentDate | date : "dd-MM-y"}}
                                  </span>
                                  <span *ngIf="kmp.KmpProfession.length==0">
                                    N/A
                                  </span>
                                </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="tab-pane" id="registerKMP" role="tabcard">
            <div class="modal-body">
              <div class="card-block datatable-card-block">
                <div class="row">
                  <div class="col-md-12">
                    <div class="margin-bottom-50">
                      <div class="table-responsive">
                        <table datatable [dtOptions]="dtOptionsOfRegisterKMP" [dtTrigger]="dtTriggerRegisterKMP" class="table table-hover compact cell-border nowrap stripe"
                          id="kmpRegisterTable" style="cursor: pointer;">
                          <thead>
                            <tr>
                              <th>KMP Name</th>
                              <th>DIN Number</th>
                              <th>Authorization Status</th>
                              <th class="actionclass">Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr *ngFor="let kmp of registerKmpList;let i=index">
                              <td tabindex="1">
                                {{kmp.FirstName}} {{kmp.MiddleName}} {{kmp.LastName}}
                              </td>
                              <td tabindex="1">
                                <span *ngIf="kmp.Din!=null">{{kmp.Din}}</span>
                                <span *ngIf="kmp.Din==null">N/A</span>
                              </td>
                              <td tabindex="1">
                                <span>{{kmp.authStatus}}</span>
                              </td>
                              <td style='white-space: nowrap'>
                                <span *ngIf="kmp.RegisterKmpStatusList.indexOf('Unauthorized')>-1">
                                  <button type="button" class="btn btn-sm btn-outline-dark" (click)="loadauthorizeData(kmp._id)">
                                    <span class="fa fa-lock">
                                    </span>
                                  </button>&nbsp;&nbsp;&nbsp;</span>
                                <span *ngIf="kmp.RegisterKmpStatusList.indexOf('Authorized')>-1">
                                  <button type="button" class="btn btn-sm btn-outline-dark" (click)="loadrectifyData(kmp._id)">
                                    <span class="fa fa-unlock"></span>
                                  </button>
                                </span>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> -->
        </div>
      </div>
    </div>
  </section>